/**
 * `img(...)` — monta uma imagem do guia juntando o RÓTULO de cada marcador (escrito aqui, no
 * conteúdo) com a POSIÇÃO medida pelo script de capturas (`marcadores.gerados.ts`).
 *
 * A posição não é digitada à mão de propósito: quando uma tela muda, roda-se o script de novo
 * e os números voltam a cair em cima do botão certo, sem ninguém medir pixel.
 */
import { POSICOES_GERADAS } from './marcadores.gerados';
import type { ImagemDoGuia } from './tipos';

export function img(
  id: string,
  alt: string,
  rotulos: readonly string[] = [],
  opcoes: { formato?: ImagemDoGuia['formato']; legenda?: string } = {},
): ImagemDoGuia {
  const posicoes = POSICOES_GERADAS[id] ?? [];
  return {
    src: `/guia/${id}.webp`,
    alt,
    formato: opcoes.formato ?? (id.startsWith('celular-') ? 'celular' : 'desktop'),
    ...(opcoes.legenda ? { legenda: opcoes.legenda } : {}),
    marcadores: rotulos.map((rotulo, i) => {
      const p = posicoes[i];
      return p ? { rotulo, x: p.x, y: p.y } : { rotulo };
    }),
  };
}
